import { useInterval } from '@chakra-ui/hooks'
import useFetch, { CachePolicies } from 'use-http'

const SessionCheck = (): null => {
  const { get } = useFetch('/api/session/check', {
    credentials: 'include',
    cachePolicy: CachePolicies.NO_CACHE,
    onError: () => {
      location.reload()
    },
    onNewData: (currData, newData) => {
      if (newData && newData.reloadRequired) {
        location.reload()
      }
    },
  })

  useInterval(() => {
    void get()
  }, 60000)

  return null
}

export default SessionCheck
